import React, { useEffect, useState } from "react";
import {Modal, Button} from 'react-bootstrap';
import APICom from "../../utils/helpers/APICom";
import {  useSelector } from "react-redux";
import ConfirmationModal from '../Controls/ConfirmationModal';
import { async } from "q";

const AssignAction = (props) => {

    
    const [showAssignAlert, setShowAssignAlert] = useState(false);
    const [assignAlert, setAssignAlert] = useState({alertTitle : '', alertMsg: ''});
    const { loginData } = useSelector((store) => store.login);
    const [confirmationModalObj, setConfirmationModalObj] = useState({show: false, title:'UnAssign Action',
    body:'', btnCanceText: 'Ok',
    btnOkText: 'Cancel'});
    const [checkAttributeViolation, setcheckAttributeViolation] = useState({});
    const [AssignParam, setAssignParam] = useState({});
    const[pauseUnPauseObj, setPauseUnPauseObj] = useState({iRefID: '-1', ServiceID: '-1', TripState: '', iUserID:'-1', iAppID: '5'});
    const BrokerDialogue = props.BrokerDialogue !== undefined ? props.BrokerDialogue : false;

    useEffect(() => {
        const Main = async () => {
            if(props.GridRowData === null || props.GridRowData.length <= 0)
            {
                setAssignAlert({...assignAlert, alertTitle: 'No trip selected', alertMsg:'Please select a trip to assign.'});
                setShowAssignAlert(true);
                return;
            }
            else
            {
                var bCheckMasterBreak = false;
                let MultiScheduleWillCallArray = [];
                var SelectedRows = props.GridRowData;
                let iAffIDOfFirstRow = SelectedRows[0].iSRATSPID
                for (let dr = 0; dr < SelectedRows.length; dr++)
                {
                    if(iAffIDOfFirstRow !== SelectedRows[dr].iSRATSPID){
                        setAssignAlert({...assignAlert, alertTitle: 'Failed', alertMsg:'All multi-selected trips should belong to the same affiliate for un-assign action.'});
                        setShowAssignAlert(true);
                        return;
                    }
                }
                for (let dr = 0; dr < SelectedRows.length; dr++)
                {
                    var MultiScheduleWillCallObj = {
                        "iRefID": "-1",
                        "iScheduleID": "-1",
                        "iScheduleDetailID": "-1",
                        "bSReturnTrip": "false",
                        "PickupDateTime": "01/01/1900"
                    }
                    if (parseInt(SelectedRows[dr].SchDetailID) > 0 && SelectedRows[dr].IsReturnTrip.toString().toLowerCase() == "false")
                    {
                        MultiScheduleWillCallObj.iRefID = SelectedRows[dr].ConfirmationNo;
                        MultiScheduleWillCallObj.iScheduleID = (SelectedRows[dr].iScheduleID === undefined) ? "-1": SelectedRows[dr].iScheduleID.toString();
                        MultiScheduleWillCallObj.iScheduleDetailID = SelectedRows[dr].SchDetailID.toString();
                        MultiScheduleWillCallObj.bSReturnTrip = SelectedRows[dr].IsReturnTrip.toString().toLowerCase();
                        MultiScheduleWillCallObj.PickupDateTime = SelectedRows[dr].PickupDateTime;
                        MultiScheduleWillCallArray.push(MultiScheduleWillCallObj);
                    }
                }
                if(MultiScheduleWillCallArray.length > 0)
                {
                    let res = await checkMultiScheduleWillCallExtendedTrip(MultiScheduleWillCallArray);
                    if(res === false) { return; }
                }

                var lstGlobalData = {
                    "ServiceID": "",
                    "ScheduleID": "",
                    "AssignedVehicleId": "",
                    "AssignedDriverId": "",
                    "MultipleClusterMode": "",
                    "NoOfESR": "",
                    "RequestDate": "",
                    "ManifestNumber": "",
                    "TripRequestStatus": "",
                    "ScheduleDetailIDs": ""
                }
                var Param = {
                    "lstGlobalData": [],
                    "ActionAssignedVehicleId": "",
                    "ActionAssignedDriverId": "",
                    "ManifestNumber": "",
                    "AffiliteID": "",
                    "AssignAffiliteOnly": "",
                    "bOnlyPreferedVehicle": "false"
                }
                var bVehSelected = true;
                var bDriverSelected = true;
                var bOnlyAssignAff = false;
                var isAffExternalChange = false;
                var iAffID = -1;
                var Vehicle = "", Driver = "";
                var modal_title = ""
                var trip_action_modal_found ;
                try {
                    modal_title = document.getElementById("contained-modal-title-vcenter").innerText;
                    trip_action_modal_found = true;
                }
                catch (e) {
                    modal_title = "Broker";
                    trip_action_modal_found = false
                }
                Vehicle = props.selectedVehicle;
                Driver = props.selectedDriver;
                
                if(typeof iAffID === "string"){
                    iAffID = parseInt(iAffID);
                }

                if (Vehicle != "" && parseInt(Vehicle) <= 0) {
                    bVehSelected = false;
                }
                if (Driver != "" && parseInt(Driver) <= 0) {
                    bDriverSelected = false;
                }
                iAffID = props.GridRowData[0].iSRATSPID
                if (!bVehSelected && !bDriverSelected && !trip_action_modal_found){
                    iAffID = props.GridRowData[0].iSRATSPID
                }
                if (iAffID < 1) {
                    if (!bVehSelected) {
                        setAssignAlert({...assignAlert, alertTitle: 'Failed', alertMsg:'Please select the vehicle.'});
                        setShowAssignAlert(true);
                        return false;
                    }
                    if (!bDriverSelected) {
                        setAssignAlert({...assignAlert, alertTitle: 'Failed', alertMsg:'Please select the driver.'});
                        setShowAssignAlert(true);
                        return false;
                    }
                }
                else if (!bVehSelected && !bDriverSelected && !trip_action_modal_found )
                    bOnlyAssignAff = true;

                Param = FillMultiSelectionActionobjects();
                Param.ActionAssignedVehicleId = Vehicle;
                Param.ActionAssignedDriverId = Driver;
                Param.AffiliteID = iAffID;
                Param.AssignAffiliteOnly = bOnlyAssignAff;
                Param.bOnlyPreferedVehicle = props.chkVehicleRequiredRef; //$("#chkVehicleRequired").is(":checked");

                setAssignParam(Param);

                var CreatedBy = props.GridRowData[0].CreatedBy;
                var RequestAffiliateID = props.GridRowData[0].RequestAffiliateID;

                var AffiliateID = props.GridRowData[0].iSRATSPID;
                var ConfirmNo = props.GridRowData[0].ConfirmationNo;
                var RequestType = props.GridRowData[0].RequestType;
                var _iServiceID = Param.lstGlobalData[0].ServiceID;
                var DataParams = Param;
                // if (DataParams.AssignAffiliteOnly == false) {
                //     if (DataParams.ActionAssignedVehicleId == "" || parseInt(DataParams.ActionAssignedVehicleId) <= -1) {
                //         setAssignAlert({...assignAlert, alertTitle: 'Vehicle Required', alertMsg:'Please select vehicle from dropdown.'});
                //         setShowAssignAlert(true);
                //         return;
                //     } else if (DataParams.ActionAssignedDriverId == "" || parseInt(DataParams.ActionAssignedDriverId) <= -1) {
                //         setAssignAlert({...assignAlert, alertTitle: 'Driver Required', alertMsg:'Please select Driver from dropdown.'});
                //         setShowAssignAlert(true);
                //         return;
                //     }
                // }
                for (let dr = 0; dr < SelectedRows.length; dr++)
                {
                    if ((SelectedRows[dr].CreatedBy.toString() === "(ExternalDispatch)" && iAffID.toString() != SelectedRows[dr].RequestAffiliateID.toString())) 
                    { 
                        isAffExternalChange = true; 
                    }
                }
                if (isAffExternalChange) {
                    setAssignAlert({...assignAlert, alertTitle: 'Action Failure', alertMsg:'Action not Allowed, Can not change Affiliate of Broker Trips.'});
                    setShowAssignAlert(true);
                    return;
                }

                console.log(ConfirmNo + ' ' + DataParams.iAssignedVehicleId + ' ' + DataParams.ActionAssignedDriverId + ' ' + 
                AffiliateID + ' ' + RequestType + ' ' + _iServiceID);
                let checkAttributeViolationObject = {};
                checkAttributeViolationObject.iRefID = ConfirmNo;
                checkAttributeViolationObject.VehicleID = Vehicle;
                checkAttributeViolationObject.DriverID = Driver;
                checkAttributeViolationObject.AffiliateID = AffiliateID;
                checkAttributeViolationObject.FID = props.GridRowData[0].iFundingSourceID;
                checkAttributeViolationObject.RequestType = RequestType;
                checkAttributeViolationObject.ServiceID = _iServiceID.toString();
                checkAttributeViolationObject.iLoginUID = loginData.iUserID;
                if(bOnlyAssignAff === false) {
                    if(BrokerDialogue){
                        await AssignAffilaites();
                    }
                    if(SelectedRows[0].Route !== ""){
                        await UpdateAssignedManifestVehicle(Driver, Vehicle);
                        // await AssignTripToDriverVehicle(Param);
                        // await SendUpdateToExternalDispatchedTrip(Vehicle, Driver, "", props.chkVehicleRequiredRef);
                        // await SendUpdateToExternalDispatch(-1, -1)
                        //await AssignAffilaites()
                        await AssignVehicleToManifest(Vehicle, Driver);
                    }
                    else{
                        await AssignTripToDriverVehicle(Param);
                        await SendUpdateToExternalDispatchedTrip(Vehicle, Driver, "", props.chkVehicleRequiredRef);
                        await SendUpdateToExternalDispatch(-1, -1)
                    }
                    
                }
                else{
                    await AssignAffilaites()
                }
                return;
                /*
                let response = await APICom.fetchData("", "TripActions/checkAttributeViolation", "post", { "Content-Type": "application/json" }, checkAttributeViolationObject, null);
                let resultattrvoil = response.data;
                setcheckAttributeViolation(resultattrvoil);
                if(resultattrvoil.Violation == "True"){
                    handleConfirmationModalOkFunction = () => {
                        handleConfirmationModalOkFunction = AssignTripToDriverVehicle;
                        if(checkAttributeViolation.Action == "bOnBreak"){
                            setConfirmationModalObj((prevState) => ({...prevState, ...{show: false, title:"Device Dispatch (Driver On-Break)", body:"Assigned Vehicle has smart device installed, but driver marked himself On-Break, Do you want to continue manual dispatch?", btnCanceText: 'Ok', btnOkText: 'Cancel'}}));
                        }
                        else if(checkAttributeViolation.Action == "bUnAvailable"){
                            setConfirmationModalObj((prevState) => ({...prevState, ...{show: false, title:"Device Dispatch (Driver Un-Available)", body:"Assigned Vehicle has smart device installed, but driver marked himself Un-Available, Do you want to continue manual dispatch?", btnCanceText: 'Ok', btnOkText: 'Cancel'}}));
                        }
                    }
                    setConfirmationModalObj((prevState) => ({...prevState, ...{show: false, title:"Attribute Violation", body:resultattrvoil.ViolationStr, btnCanceText: 'Ok', btnOkText: 'Cancel'}}));
                }
                UnMountAssignActionCompoennt();*/
            }
        }
        Main();
        return () => {
            // Perform cleanup operations if needed
        };
    }, []);

    async function AssignVehicleToManifest (vehicleid, driverid){

        let SelectedRecordsArray = props.GridRowData;
        let serviceIDs = "";
        let scheduleIDs = "";
        let iAffiliateID = props.selectedAffiliate && props.selectedAffiliate !== "" ? props.selectedAffiliate : SelectedRecordsArray[0].iSRATSPID;

        // Get unique manifest numbers that are not empty, undefined, or null
        const manifestNumbers = Array.from(
            new Set(
              SelectedRecordsArray.map((record) => record.vManifestNumber)
                .filter((number) => number !== '' && number !== undefined && number !== null)
            )
          );
    
          if (manifestNumbers.length > 0) {
            let service_ids = '';
            let schedule_ids = '';
            let ODServiceIDs = '';
            let SchServiceIDs = '';
    
            for (const manifestNumber of manifestNumbers) {
              if (manifestNumber) {
                try {
                    let params = {
                        "vManifestNumber": manifestNumber
                    }
                    let ManifiestTripsDT = await APICom.fetchData("", "TripActions/GetTripsinManifestAssignedQueue", "post", { "Content-Type": "application/json" }, params, null);
                    for (const trip of ManifiestTripsDT.data) {
                        const bWillCallRequest = String(trip.bWillCallRequest).toLowerCase() === 'true';
                        if (!bWillCallRequest) {
                          service_ids += String(trip.ServiceID) + ',';
                        } else {
                          schedule_ids += String(trip.iScheduleID) + ',';
                        }
          
                        if (trip.ServiceID) {
                          ODServiceIDs += String(trip.ServiceID) + ',';
                        }
                        let requestObj = {
                            "iServiceID": parseInt(trip.ServiceID),
                            "iAssignedVehicleId": parseInt(vehicleid),
                            "iAssignedDriverId": parseInt(driverid),
                            "sDisposition":"-1",
                            "ULoginID":loginData.iUserID,
                            "vRoute":trip.Route,
                            "iAffID":iAffiliateID,
                            "iCallingFrom": 1,
                            "bOnlyPreferedVehicle": props.chkVehicleRequiredRef
                        }
                        // pauseUnPauseObj["iUserID"] = loginData.iUserID;
                        // pauseUnPauseObj["ServiceID"] = trip.ServiceID;
                        // pauseUnPauseObj["iAppID"] = '26'
                        // pauseUnPauseObj["TripState"] = 'Paused'
                        // pauseUnPauseObj["iRefID"] = trip.Confirmation
                        // let response1 = await APICom.fetchData("", "TripActions/PauseUnPauseTripState", "post", { "Content-Type": "application/json" }, pauseUnPauseObj, null);
                        
                        let response = await APICom.fetchData("", "TripActions/UpdateAssignedManifestVehicle", "post", { "Content-Type": "application/json" }, requestObj, null);
                        
                    }
                        setAssignAlert({...assignAlert, alertTitle: 'Assignment Successful', alertMsg:'Trip(s) assigned successfully.'});
                        setShowAssignAlert(true);
                        props.setAssignProcessing(false)
                    // try {

                    //     if (service_ids || schedule_ids) {
                    //         service_ids = service_ids.trimEnd(',');
                    //         schedule_ids = schedule_ids.trimEnd(',');

                    //         let PauseOrUnPauseObj = {
                    //             "ServiceIDs": service_ids,
                    //             "ScheduleIDs" : schedule_ids,
                    //             "iModifiedUID": loginData.iUserID,
                    //             "IsPause": true
                    //         }
                    //         let response = await APICom.fetchData("", "TripActions/PauseORUnPauseTrips", "post", { "Content-Type": "application/json" }, PauseOrUnPauseObj, null);
                    //         setAssignAlert({...assignAlert, alertTitle: 'Assignment Successful', alertMsg:'Trip(s) assigned successfully.'});
                    //         setShowAssignAlert(true);
                    //         props.setAssignProcessing(false)
                    //     }
                        
                    //   } catch (error) {
                    //     console.error('Error pausing/unpausing trips:', error);
                    //   }
               
                }
                catch{}
            }
        }
    }

}
    async function AssignAffilaites(){
        //If first row manifest then GetManifestnAssignedRequestQueue, and perform affiliates on all trips of manifest.
        let SelectedRecordsArray = props.GridRowData;
        let serviceIDs = "";
        let scheduleIDs = "";
        let iAffiliateID = props.selectedAffiliate && props.selectedAffiliate !== "" ? props.selectedAffiliate : SelectedRecordsArray[0].iSRATSPID;

        // Get unique manifest numbers that are not empty, undefined, or null
        const manifestNumbers = Array.from(
            new Set(
              SelectedRecordsArray.map((record) => record.vManifestNumber)
                .filter((number) => number !== '' && number !== undefined && number !== null)
            )
          );
    
          if (manifestNumbers.length > 0) {
           
            let ODServiceIDs = '';
            let SchServiceIDs = '';
    
            for (const manifestNumber of manifestNumbers) {
              if (manifestNumber) {

                try {

                    let service_ids = '';
                    let schedule_ids = '';

                    let params = {
                        "vManifestNumber": manifestNumber
                    }
    
                    let ManifiestTripsDT = await APICom.fetchData("", "TripActions/GetTripsinManifestAssignedQueue", "post", { "Content-Type": "application/json" }, params, null);
                
                
                    for (const trip of ManifiestTripsDT.data) {
                        const bWillCallRequest = String(trip.bWillCallRequest).toLowerCase() === 'true';
        
                        if (!bWillCallRequest) {
                        service_ids += String(trip.ServiceID) + ',';
                        } else {
                        schedule_ids += String(trip.iScheduleID) + ',';
                        }
        
                        if (trip.ServiceID) {
                        ODServiceIDs += String(trip.ServiceID) + ',';
                        }
                    }
        
                    try 
                    {
                        service_ids = service_ids.endsWith(',') ? service_ids.slice(0, -1) : service_ids;
                        schedule_ids = schedule_ids.endsWith(',') ? schedule_ids.slice(0, -1) : schedule_ids;

                        // let PauseORUnPauseTripsObj = {
                        //     "ServiceIDs": service_ids,
                        //     "ScheduleIDs" : schedule_ids,
                        //     "iModifiedUID": loginData.iUserID,
                        //     "IsPause": true
                        // }


                        // let response1 = await APICom.fetchData("", "TripActions/PauseORUnPauseTrips", "post", { "Content-Type": "application/json" }, PauseORUnPauseTripsObj, null);
        
                        let requestObj = {
                            "iODserviceIDs": service_ids,
                            "iSchserviceIDs": schedule_ids,
                            "iAffID": iAffiliateID,
                            "ULoginID": loginData.iUserID,
                            "bManualAssignment": true
                            }
                        let response = await APICom.fetchData("", "TripActions/AssignAffilaites", "post", { "Content-Type": "application/json" }, requestObj, null);
                        if(BrokerDialogue === true) {
                        setAssignAlert({...assignAlert, alertTitle: 'Assignment Successful', alertMsg:'Trip(s) assigned successfully.'});
                        setShowAssignAlert(true);
                        props.setAssignProcessing(false);
                        }
            
                        
                        } catch (error) {}


                        //   try {

                        //     if (service_ids || schedule_ids) {


                        //         service_ids = service_ids.trimEnd(',');
                        //         schedule_ids = schedule_ids.trimEnd(',');

                        //         let PauseOrUnPauseObj = {
                        //             "ServiceIDs": service_ids,
                        //             "ScheduleIDs" : schedule_ids,
                        //             "iModifiedUID": loginData.iUserID,
                        //             "IsPause": true
                        //         }

                        //         let response = await APICom.fetchData("", "TripActions/PauseORUnPauseTrips", "post", { "Content-Type": "application/json" }, PauseOrUnPauseObj, null);

                        //     }

                            
                            
                        //   } catch (error) {
                        //     console.error('Error pausing/unpausing trips:', error);
                        //   }
                    }   
                catch (error) {}

              }
            }
          }

          else{

            SelectedRecordsArray.forEach((SelectedRecords, index) => {
                let ScheduleIDD = -1;
                let serviceID = -1;
                try{
                    if(isNaN((SelectedRecords.iScheduleID === undefined) ? "-1": SelectedRecords.iScheduleID) === false){
                        ScheduleIDD = parseInt((SelectedRecords.iScheduleID === undefined) ? "-1": SelectedRecords.iScheduleID);
                    }
                    if(isNaN((SelectedRecords.ServiceID === undefined) ? "-1": SelectedRecords.ServiceID) === false){
                        serviceID = parseInt((SelectedRecords.ServiceID === undefined) ? "-1": SelectedRecords.ServiceID);
                    }
                }
                catch(err){
    
                }
                let _tablesourceOndemand = false;
                try{
                    _tablesourceOndemand = (SelectedRecords.TableSource === "FromOnDemandTable" ? true: false);
                }
                catch(io){ }
                if(ScheduleIDD > 0 && _tablesourceOndemand === false){
                    scheduleIDs +="," + serviceID.toString();
                }
                else{
                    serviceIDs +="," + SelectedRecords.ServiceID.toString();
                }
            });
            try{
                scheduleIDs = scheduleIDs.substring(1);
            }
            catch(err){}
            try{
                serviceIDs = serviceIDs.substring(1);
            }
            catch(err){}
            let requestObj = {
                "iODserviceIDs": serviceIDs,
                "iSchserviceIDs": scheduleIDs,
                "iAffID": iAffiliateID,
                "ULoginID": loginData.iUserID,
                "bManualAssignment": true
            }
            let response = await APICom.fetchData("", "TripActions/AssignAffilaites", "post", { "Content-Type": "application/json" }, requestObj, null);
            setAssignAlert({...assignAlert, alertTitle: 'Assignment Successful', alertMsg:'Trip(s) assigned successfully.'});
            setShowAssignAlert(true);
            props.setAssignProcessing(false)

          }




    }
    async function SendUpdateToExternalDispatchedTrip(vehicleID, driverID, vSchDetailIDs, bOnlyPreferedVehicle){
        //If first row manifest then GetManifestnAssignedRequestQueue, and perform affiliates on all trips of manifest.
        let SelectedRecordsArray = props.GridRowData;
        let serviceIDs = "";
        let scheduleIDs = "";
        let iAffiliateID = SelectedRecordsArray[0].iSRATSPID;
        SelectedRecordsArray.forEach((SelectedRecords, index) => {
            let ScheduleIDD = -1;
            let serviceID = -1;
            try{
                if(isNaN((SelectedRecords.iScheduleID === undefined) ? "-1": SelectedRecords.iScheduleID) === false){
                    ScheduleIDD = parseInt((SelectedRecords.iScheduleID === undefined) ? "-1": SelectedRecords.iScheduleID);
                }
                if(isNaN((SelectedRecords.ServiceID === undefined) ? "-1": SelectedRecords.ServiceID) === false){
                    serviceID = parseInt((SelectedRecords.ServiceID === undefined) ? "-1": SelectedRecords.ServiceID);
                }
            }
            catch(err){

            }
            if(ScheduleIDD > 0){
                scheduleIDs +="," + serviceID.toString();
            }
            else{
                serviceIDs +="," + SelectedRecords.ServiceID.toString();
            }
        });
        try{
            scheduleIDs = scheduleIDs.substring(1);
        }
        catch(err){}
        try{
            serviceIDs = serviceIDs.substring(1);
        }
        catch(err){}
        let requestObj = {
            "iODserviceIDs": serviceIDs,
            "iSchserviceIDs": scheduleIDs,
            "iAffID": parseInt(iAffiliateID),
            "vehicleID":-1,
            "driverID":-1,
            "vSchDetailIDs":"",
            "bOnlyPreferedVehicle":bOnlyPreferedVehicle,
            "ULoginID": loginData.iUserID,
            "bManualAssignment": true
        }
        let response = await APICom.fetchData("", "TripActions/SendUpdateToExternalDispatchedTrip_For_AssignAffilaites", "post", { "Content-Type": "application/json" }, requestObj, null);
    }
    async function UpdateAssignedManifestVehicle(driverid, vehicleid){
        let SelectedRecordd = props.GridRowData[0];
        if(SelectedRecordd.Route !== ""){
            if (SelectedRecordd.TableSource == "FromScheduleTable") {
                let requestObj = {
                    "iServiceID": parseInt(SelectedRecordd.ServiceID),
                    "iAssignedVehicleId": parseInt(vehicleid),
                    "iAssignedDriverId": parseInt(driverid),
                    "sDisposition":"-1",
                    "ULoginID":loginData.iUserID,
                    "vRoute":SelectedRecordd.Route,
                    "vManifestNumber":SelectedRecordd.vManifestNumber,
                    "AffiliateID":SelectedRecordd.iSRATSPID,
                    "iScheduleDetailID": -1,
                    "bOnlyPreferedVehicle": props.chkVehicleRequiredRef
                }
                let response = await APICom.fetchData("", "TripActions/UpdateAssignVehicleToManifestReqSSRQ", "post", { "Content-Type": "application/json" }, requestObj, null);
            }
            else{
                let requestObj = {
                    "iServiceID": parseInt(SelectedRecordd.ServiceID),
                    "iAssignedVehicleId": parseInt(vehicleid),
                    "iAssignedDriverId": parseInt(driverid),
                    "sDisposition":"-1",
                    "ULoginID":loginData.iUserID,
                    "vRoute":SelectedRecordd.Route,
                    "iAffID":SelectedRecordd.iSRATSPID,
                    "iCallingFrom": 1,
                    "bOnlyPreferedVehicle": props.chkVehicleRequiredRef
                }
                let response = await APICom.fetchData("", "TripActions/UpdateAssignedManifestVehicle2", "post", { "Content-Type": "application/json" }, requestObj, null);
            }
        }
    }
    async function SendUpdateToExternalDispatch(driverid, vehicleid){
        let SelectedRecordd = props.GridRowData[0]
        let requestObj = {
            "iODserviceIDs": "",
            "iSchserviceIDs": "",
            "vehicleID": parseInt(vehicleid),
            "driverID": parseInt(driverid),
            "bManualAssignment": true,
            "iAffID":SelectedRecordd.iSRATSPID,
            "bOnlyPreferedVehicle": props.chkVehicleRequiredRef,
            "iUserIID": loginData.iUserID,
            "vSchDetailIDs": ""
        }
        let response = await APICom.fetchData("", "TripActions/AssignAffilaitesVehiclesDrivers", "post", { "Content-Type": "application/json" }, requestObj, null);
    
    }
    async function AssignTripToDriverVehicle(AssParam) {
        let Param = AssParam;
        let length = Param.lstGlobalData.length;
        let vehicleID = -1;
        let driverID = -1;
        let iAffID = -1;
        let bOnlyAssignAffiliate = false;
        let bMultiScheduleAssignment = false;
        let bOnlyPreferedVehicle = false;

        vehicleID = parseInt(Param.ActionAssignedVehicleId)
        driverID = parseInt(Param.ActionAssignedDriverId)
        iAffID = parseInt(Param.AffiliteID)
        bOnlyAssignAffiliate = Param.AssignAffiliteOnly
        bOnlyPreferedVehicle = Param.bOnlyPreferedVehicle

        for (const item of Param.lstGlobalData) {
            let iAssignedVehicleID = -1;
            let iAssignedDriverId = -1;
            if(typeof item.iAssignedVehicleId !== 'undefined'){
                if(item.iAssignedVehicleId !== null){
                    iAssignedVehicleID = item.iAssignedVehicleId;
                }
            }
            if(typeof item.AssignedDriverId !== 'undefined'){
                if(item.AssignedDriverId !== null){
                    iAssignedDriverId = item.AssignedDriverId;
                }
            }

            let requestObj = {
                "iServiceID": item.ServiceID,
                "iAssignedVehicleId": vehicleID,
                "iAssignedDriverId": driverID,
                "ULoginID": loginData.iUserID,
                "iModifiedByAppID": 26,
                "bOnlyPreferedVehicle": bOnlyPreferedVehicle
            }
            let response = await APICom.fetchData("", "TripActions/UpdateAssignedVehicle", "post", { "Content-Type": "application/json" }, requestObj, null);
        }
        setAssignAlert({...assignAlert, alertTitle: 'Assignment Successful', alertMsg:'Trip(s) assigned successfully.'});
        setShowAssignAlert(true);
        return;
    }
    function FillMultiSelectionActionobjects() {

        var Param = {
            "lstGlobalData": [],
            "ActionAssignedVehicleId": "",
            "ActionAssignedDriverId": "",
            "ManifestNumber": "",
            "AffiliteID": "",
            "AssignAffiliteOnly": ""
        }
    
        try {
            var ProssedRecordList = new Array();
            var ProssedManifestList = new Array();
            let SelectedRecordsArray = props.GridRowData;
            //Object.keys(SelectedRecords).length === 0
            SelectedRecordsArray.forEach((SelectedRecords, index) => {
            if (Object.keys(SelectedRecords).length !== 0) {
                var MKPMs = {
                    "ServiceID": "", "ScheduleID": "", "AssignedVehicleId": "", "AssignedDriverId": "", "MultipleClusterMode": "",
                    "NoOfESR": "", "RequestDate": "", "ManifestNumber": "", "TripRequestStatus": "", "ScheduleDetailIDs": "", "MSchWC" : ""
                }
    
                try {
                    if (SelectedRecords.bIsSchedule.toString().toLowerCase() == "true") {
                        MKPMs.ScheduleID = ((SelectedRecords.iScheduleID == null || SelectedRecords.iScheduleID.toString().trim() == "") ? "-1" : SelectedRecords.iScheduleID.toString());
                    }
                    MKPMs.ServiceID = SelectedRecords.ServiceID.toString();
                    MKPMs.ScheduleDetailIDs = SelectedRecords.SchDetailID.toString().trim();
                    MKPMs.MSchWC = ((SelectedRecords.PickupTime == "MSchWC") ? "true" : "false");
                    if (SelectedRecords.vManifestNumber == null || SelectedRecords.vManifestNumber.toString().trim() == "") {
                        
                    }
                    else if (!ProssedManifestList.includes(SelectedRecords.vManifestNumber)) {
                        Param.ManifestNumber += SelectedRecords.vManifestNumber.toString() + ",";
                        ProssedManifestList.push(SelectedRecords.vManifestNumber);
                    }
    
                    MKPMs.AssignedVehicleId = SelectedRecords.iAssignedVehicleId;
                    MKPMs.AssignedDriverId = SelectedRecords.AssignedDriverId;
                    MKPMs.TripRequestStatus = SelectedRecords.TripRequestStatus;
                    MKPMs.Queue = "";
    
                    ProssedRecordList.push(SelectedRecords.ConfirmationNo);
    
                    Param.lstGlobalData.push(MKPMs);
                }
                catch (abc) { console.log(abc); }
            }
        
    
            try {
                if (!ProssedRecordList.includes(SelectedRecords.ConfirmationNo)) {
    
                    var MKPMs = {
                        "ServiceID": "", "ScheduleID": "", "AssignedVehicleId": "", "AssignedDriverId": "", "MultipleClusterMode": "",
                        "NoOfESR": "", "RequestDate": "", "ManifestNumber": "", "TripRequestStatus": "", "ScheduleDetailIDs": "", "MSchWC": ""
                    }
                    MKPMs.Queue = "";
                    try {
                        if ((SelectedRecords.vManifestNumber == null || SelectedRecords[0].vManifestNumber.toString() == "")) {
                            if (SelectedRecords.bIsSchedule.toString().toLowerCase() == "true") {
                                MKPMs.ScheduleID = ((SelectedRecords.iScheduleID == null || SelectedRecords.iScheduleID.toString() == "") ? "-1" : SelectedRecords[0].iScheduleID);
                            }
                            MKPMs.ServiceID = SelectedRecords.ServiceID;
                            MKPMs.ScheduleDetailIDs = SelectedRecords.SchDetailID.toString().trim();
                            MKPMs.AssignedVehicleId = SelectedRecords.iAssignedVehicleId;
                            MKPMs.AssignedDriverId = SelectedRecords.AssignedDriverId;
                            MKPMs.TripRequestStatus = SelectedRecords.TripRequestStatus;
                            MKPMs.MSchWC = ((SelectedRecords.PickupTime == "MSchWC") ? "true" : "false");
                            MKPMs.Queue = "";
    
                            Param.lstGlobalData.push(MKPMs);
                        }
                        else if (!ProssedManifestList.includes(SelectedRecords.vManifestNumber)) {
                            Param.ManifestNumber += SelectedRecords.vManifestNumber.ToString();
                            ProssedRecordList.push(SelectedRecords.vManifestNumber);
                        }
                    }
                    catch (afw) { }
                }
    
            }
            catch (asd) { }
        });
        } catch (FillMultiSelectionActionobjectsException) { console.log(FillMultiSelectionActionobjectsException); }
    
        return Param;
    }


    const checkMultiScheduleWillCallExtendedTrip = async(MultiScheduleWillCallArray) => {
        var bProceeed = true;
        let multischedulewc = MultiScheduleWillCallArray;
        let response = await APICom.fetchData("", "TripActions/checkMultiScheduleWillCallExtendedTripMulti", "post", { "Content-Type": "application/json" }, multischedulewc, null);
        let result = response.data;
        if (result.proceed.toString().toLowerCase() == "false") {
            setAssignAlert({...assignAlert, alertTitle: 'Expand Multi-Schedule', alertMsg:`ConfirmationNo : " ${result.iRefID.toString()} " has a master leg, which is not yet expanded. Please first expand master leg by 'Assign' or 'Due-Now' action.`});
            setShowAssignAlert(true);
            return false;
            //handleAssignAlertModalClose will get called upon close of the modal.
        }
        return true;
    }

    const handleAssignAlertModalClose = () => {
        setShowAssignAlert(false);
        UnMountAssignActionCompoennt();
    }

    const UnMountAssignActionCompoennt = () => {
        if(props.invokeAssignComponent)
        {
            console.log("UnMount Assign Component");
            props.setInvokeAssignComponent(false);
        }
    }
    var handleConfirmationModalOkFunction = () => {
        alert("Ok clicked")
    }
    const handleConfirmationModalOk = () => {
        setConfirmationModalObj((prevState) => ({...prevState, show:false}));
        handleConfirmationModalOkFunction();
    }

    const handleConfirmationModalCancel = () => {
        setConfirmationModalObj((prevState) => ({...prevState, show:false}));
        UnMountAssignActionCompoennt();
    }

    return(
        <>
        <Modal centered show={showAssignAlert}  animation={false} >
                                  <Modal.Header style={{height: "50px"}} closeButton>
                                    <Modal.Title>{assignAlert.alertTitle}</Modal.Title>
                                  </Modal.Header>
                                  <Modal.Body><b>{assignAlert.alertMsg}</b></Modal.Body>
                                  <Modal.Footer>
                                    <Button variant="secondary" onClick={handleAssignAlertModalClose}>
                                      Close
                                    </Button>
                                  </Modal.Footer>
                                </Modal>
         <ConfirmationModal show={confirmationModalObj.show} Title={confirmationModalObj.title} Body={confirmationModalObj.body}
        onOk={handleConfirmationModalOk} onCancel={handleConfirmationModalCancel} btnCanceText={confirmationModalObj.btnCanceText}
        btnOkText={confirmationModalObj.btnOkText} />
        </>
    );
}

export default AssignAction;